import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-52b39f1a")

_pushScopeId("data-v-52b39f1a")
const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "divider" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _hoisted_3,
    _withDirectives(_createVNode("select", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedItem = $event)),
      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSelect && _ctx.onSelect(...args)))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock("option", {
          key: item.id,
          value: item
        }, _toDisplayString(item[_ctx.displayTextKey]), 9, ["value"]))
      }), 128))
    ], 544), [
      [_vModelSelect, _ctx.selectedItem]
    ])
  ]))
})